export const localStorageSet = (key, obj) =>
    localStorage.setItem(key, JSON.stringify(obj));

export const localStorageGet = (key) => JSON.parse(localStorage.getItem(key));
